// extracted by mini-css-extract-plugin
export default {"pageContainer":"terms-and-conditions_pageContainer__-mwHd"};